import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-8" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex flex-col items-center justify-center mx-auto"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "w-36 h-36 rounded-full mx-auto bg-white"
}
const _hoisted_5 = { class: "w-full text-gray-600 px-0 mx-auto flex justify-center" }
const _hoisted_6 = { class: "w-full space-y-4 pb-5" }
const _hoisted_7 = { class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = {
  key: 0,
  class: "w-full text-xs"
}
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_12 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_13 = { class: "text-sm text-red-500 p-error" }
const _hoisted_14 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_15 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_16 = { class: "text-sm text-red-500 p-error" }
const _hoisted_17 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_20 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_23 = { class: "text-sm text-red-500 p-error" }
const _hoisted_24 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_25 = { class: "text-sm text-red-500 p-error" }
const _hoisted_26 = {
  key: 0,
  class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5"
}
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_29 = { class: "w-full px-2 md:w-8/12" }
const _hoisted_30 = { class: "text-sm text-red-500 p-error" }
const _hoisted_31 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_32 = { class: "text-sm text-red-500 p-error" }
const _hoisted_33 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_34 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_35 = { class: "text-sm text-red-500 p-error" }
const _hoisted_36 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_37 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_38 = { class: "text-sm text-red-500 p-error" }
const _hoisted_39 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_40 = { class: "text-sm text-red-500 p-error" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["empresaRedSocial"]
const _hoisted_43 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_44 = { class: "w-full px-2" }
const _hoisted_45 = {
  key: 1,
  class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3 pb-5"
}
const _hoisted_46 = { class: "w-full" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = ["tag"]
const _hoisted_49 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_50 = { class: "w-full px-2" }
const _hoisted_51 = { class: "block mb-1" }
const _hoisted_52 = { class: "relative w-full shadow-lg rounded-lg bg-white px-4 py-3" }
const _hoisted_53 = { class: "container w-full" }
const _hoisted_54 = { class: "flex flex-wrap gap-2" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_57 = { class: "pi pi-check mr-2" }
const _hoisted_58 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InputGroupAddon = _resolveComponent("InputGroupAddon")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Form = _resolveComponent("Form")!
  const _component_CommonPrivateView = _resolveComponent("CommonPrivateView")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_ModalFileUpload = _resolveComponent("ModalFileUpload")!
  const _component_CropperView = _resolveComponent("CropperView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CommonPrivateView, null, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.empresa)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.empresa.previewLogo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.empresa.previewLogo,
                      class: "w-36 h-36 rounded-full mx-auto"
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4)),
                (_ctx.empresa)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFileUploadVisible = true)),
                      class: "cursor-pointer mt-3 py-2 px-4 block rounded-lg border border-white bg-transparent text-white hover:bg-black hover:text-white"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'upload'] }),
                      _cache[14] || (_cache[14] = _createTextVNode(" SUBIR LOGO "))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        (_ctx.empresa)
          ? (_openBlock(), _createBlock(_component_Form, {
              key: 0,
              onSubmit: _ctx.onSubmit,
              class: "w-full",
              "validation-schema": _ctx.schema,
              onInvalidSubmit: _ctx.onInvalidSubmit
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "font-semibold text-lg" }, " MI EMPRESA ", -1)),
                        (_ctx.empresa)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass([_ctx.empresa.activo ? 'bg-green-600' : 'bg-red-600', "text-white text-xs font-semibold px-2 py-1 rounded-md h-full flex items-center"])
                            }, _toDisplayString(_ctx.empresa.activo ? 'ACTIVA' : 'INACTIVA'), 3))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.empresa)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Fecha de alta : " + _toDisplayString(_ctx.formatDate(new Date(_ctx.empresa.fechaAlta), 'dd/MM/yyyy HH:mm:ss')) + " | Fecha de actualización : " + _toDisplayString(_ctx.formatDate(new Date(_ctx.empresa.fechaModificacion), 'dd/MM/yyyy HH:mm:ss')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-1" }, "Razón social", -1)),
                            _createVNode(_component_Field, {
                              name: "razonSocial",
                              modelValue: _ctx.empresa.razonSocial,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.empresa.razonSocial) = $event))
                            }, {
                              default: _withCtx(({ field, errors }) => [
                                _createVNode(_component_InputText, _mergeProps(field, {
                                  type: "text",
                                  placeholder: "Razón social",
                                  class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                }), null, 16, ["class"]),
                                _createElementVNode("span", _hoisted_13, [
                                  _createVNode(_component_ErrorMessage, { name: "razonSocial" })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-1" }, "País", -1)),
                            _createVNode(_component_Field, {
                              name: "pais",
                              modelValue: _ctx.empresa.pais,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.empresa.pais) = $event))
                            }, {
                              default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                                _createVNode(_component_Dropdown, {
                                  onBlur: handleBlur,
                                  filter: "",
                                  "onUpdate:modelValue": handleChange,
                                  "model-value": value,
                                  placeholder: "Seleccioná el país",
                                  class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                                  options: _ctx.paises,
                                  optionLabel: "descripcion"
                                }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                                _createElementVNode("span", _hoisted_16, [
                                  _createVNode(_component_ErrorMessage, { name: "pais" })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block mb-1" }, "Provincia / Estado", -1)),
                            _createVNode(_component_Field, {
                              name: "provincia",
                              modelValue: _ctx.empresa.provincia,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.empresa.provincia) = $event))
                            }, {
                              default: _withCtx(({ field, errors }) => [
                                _createVNode(_component_InputText, _mergeProps(field, {
                                  type: "text",
                                  placeholder: "Provincia / Estado",
                                  class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                }), null, 16, ["class"]),
                                _createElementVNode("span", _hoisted_18, [
                                  _createVNode(_component_ErrorMessage, { name: "provincia" })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-1" }, "Localidad / Ciudad", -1)),
                            _createVNode(_component_Field, {
                              name: "localidad",
                              modelValue: _ctx.empresa.localidad,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.empresa.localidad) = $event))
                            }, {
                              default: _withCtx(({ field, errors }) => [
                                _createVNode(_component_InputText, _mergeProps(field, {
                                  type: "text",
                                  placeholder: "Localidad / Ciudad",
                                  class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                }), null, 16, ["class"]),
                                _createElementVNode("span", _hoisted_21, [
                                  _createVNode(_component_ErrorMessage, { name: "localidad" })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block mb-1" }, "C.P.", -1)),
                            _createVNode(_component_Field, {
                              name: "codigoPostal",
                              modelValue: _ctx.empresa.codigoPostal,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.empresa.codigoPostal) = $event))
                            }, {
                              default: _withCtx(({ field, errors }) => [
                                _createVNode(_component_InputText, _mergeProps(field, {
                                  type: "text",
                                  placeholder: "Código postal",
                                  class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                }), null, 16, ["class"]),
                                _createElementVNode("span", _hoisted_23, [
                                  _createVNode(_component_ErrorMessage, { name: "codigoPostal" })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block mb-1" }, "Domicilio", -1)),
                            _createVNode(_component_Field, {
                              name: "domicilio",
                              modelValue: _ctx.empresa.domicilio,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.empresa.domicilio) = $event))
                            }, {
                              default: _withCtx(({ field, errors }) => [
                                _createVNode(_component_InputText, _mergeProps(field, {
                                  type: "text",
                                  placeholder: "Domicilio",
                                  class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                }), null, 16, ["class"]),
                                _createElementVNode("span", _hoisted_25, [
                                  _createVNode(_component_ErrorMessage, { name: "domicilio" })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.empresa && _ctx.completaPerfil)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " DATOS COMERCIALES Y DE CONTACTO ", -1)),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block mb-1" }, "Nombre de fantasía", -1)),
                                _createVNode(_component_Field, {
                                  name: "nombreFantasia",
                                  modelValue: _ctx.empresa.nombreFantasia,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.empresa.nombreFantasia) = $event))
                                }, {
                                  default: _withCtx(({ field, errors }) => [
                                    _createVNode(_component_InputText, _mergeProps(field, {
                                      type: "text",
                                      placeholder: "Nombre de fantasía",
                                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                    }), null, 16, ["class"]),
                                    _createElementVNode("span", _hoisted_30, [
                                      _createVNode(_component_ErrorMessage, { name: "nombreFantasia" })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_31, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block mb-1" }, "Stand", -1)),
                                _createVNode(_component_Field, {
                                  name: "stand",
                                  modelValue: _ctx.empresa.stand,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.empresa.stand) = $event))
                                }, {
                                  default: _withCtx(({ field, errors }) => [
                                    _createVNode(_component_InputText, _mergeProps(field, {
                                      type: "text",
                                      placeholder: "Stand",
                                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                    }), null, 16, ["class"]),
                                    _createElementVNode("span", _hoisted_32, [
                                      _createVNode(_component_ErrorMessage, { name: "stand" })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block mb-1" }, "Breve descripción", -1)),
                                _createVNode(_component_Field, {
                                  name: "breveDescripcion",
                                  modelValue: _ctx.empresa.breveDescripcion,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.empresa.breveDescripcion) = $event))
                                }, {
                                  default: _withCtx(({ field, errors }) => [
                                    _createVNode(_component_Textarea, _mergeProps({ rows: "4" }, field, {
                                      type: "text",
                                      placeholder: "Breve descripción de la empresa",
                                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                    }), null, 16, ["class"]),
                                    _createElementVNode("span", _hoisted_35, [
                                      _createVNode(_component_ErrorMessage, { name: "breveDescripcion" })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block mb-1" }, "Mail comercial", -1)),
                                _createVNode(_component_Field, {
                                  name: "mailComercial",
                                  modelValue: _ctx.empresa.mailComercial,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.empresa.mailComercial) = $event))
                                }, {
                                  default: _withCtx(({ field, errors }) => [
                                    _createVNode(_component_InputText, _mergeProps(field, {
                                      type: "mail",
                                      placeholder: "Mail comercial",
                                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                    }), null, 16, ["class"]),
                                    _createElementVNode("span", _hoisted_38, [
                                      _createVNode(_component_ErrorMessage, { name: "mailComercial" })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono comercial", -1)),
                                _createVNode(_component_Field, {
                                  name: "telefono",
                                  modelValue: _ctx.empresa.telefono,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.empresa.telefono) = $event))
                                }, {
                                  default: _withCtx(({ field, errors }) => [
                                    _createVNode(_component_InputText, _mergeProps(field, {
                                      type: "text",
                                      placeholder: "Teléfono comercial",
                                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                                    }), null, 16, ["class"]),
                                    _createElementVNode("span", _hoisted_40, [
                                      _createVNode(_component_ErrorMessage, { name: "telefono" })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            (_ctx.empresa)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empresa.empresaRedesSociales, (empresaRedSocial) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: empresaRedSocial.id,
                                      empresaRedSocial: empresaRedSocial
                                    }, [
                                      _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("div", _hoisted_44, [
                                          _createVNode(_component_InputGroup, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_InputGroupAddon, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_font_awesome_icon, {
                                                    class: "text-black",
                                                    icon: empresaRedSocial.redSocial.icono.split(' ')
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_Field, {
                                                name: `link-${empresaRedSocial.id}`,
                                                modelValue: empresaRedSocial.link,
                                                "onUpdate:modelValue": ($event: any) => ((empresaRedSocial.link) = $event)
                                              }, {
                                                default: _withCtx(({ field, errors }) => [
                                                  _createVNode(_component_InputText, {
                                                    modelValue: empresaRedSocial.link,
                                                    "onUpdate:modelValue": ($event: any) => ((empresaRedSocial.link) = $event),
                                                    placeholder: empresaRedSocial.redSocial.descripcion,
                                                    class: _normalizeClass(["input-group-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }])
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class"])
                                                ]),
                                                _: 2
                                              }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ])
                                    ], 8, _hoisted_42))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.empresa && _ctx.completaPerfil)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "flex items-center justify-between font-semibold text-lg" }, " CATEGORÍAS ", -1)),
                          _createElementVNode("div", _hoisted_46, [
                            (_ctx.tags)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: tag.id,
                                      tag: tag
                                    }, [
                                      _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                          _createElementVNode("label", _hoisted_51, _toDisplayString(tag.descripcion), 1),
                                          _createVNode(_component_Field, {
                                            name: `tag-${tag.id}`
                                          }, {
                                            default: _withCtx(({ errors }) => [
                                              _createVNode(_component_MultiSelect, {
                                                "model-value": tag.opcionesTagSeleccionados,
                                                "onUpdate:modelValue": val => tag.opcionesTagSeleccionados = val,
                                                options: tag.opciones,
                                                optionLabel: "descripcion",
                                                optionValue: "id",
                                                filter: "",
                                                placeholder: tag.descripcion,
                                                class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && tag.opcionesTagSeleccionados?.length > 0, 'input-error': errors.length > 0 }])
                                              }, null, 8, ["model-value", "onUpdate:modelValue", "options", "placeholder", "class"])
                                            ]),
                                            _: 2
                                          }, 1032, ["name"])
                                        ])
                                      ])
                                    ], 8, _hoisted_48))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("button", {
                            type: "submit",
                            class: "px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                            disabled: _ctx.isSubmitting
                          }, [
                            _withDirectives(_createElementVNode("i", _hoisted_56, null, 512), [
                              [_vShow, _ctx.isSubmitting]
                            ]),
                            _withDirectives(_createElementVNode("i", _hoisted_57, null, 512), [
                              [_vShow, !_ctx.isSubmitting]
                            ]),
                            _cache[29] || (_cache[29] = _createTextVNode("ACEPTAR "))
                          ], 8, _hoisted_55),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.cancelarModificacion && _ctx.cancelarModificacion(...args))),
                            class: "px-4 py-2 bg-transparent border-red-700 hover:bg-red-700 text-red-700 font-semibold hover:text-white border rounded",
                            disabled: _ctx.isSubmitting
                          }, _cache[30] || (_cache[30] = [
                            _createElementVNode("i", { class: "pi pi-times mr-2" }, null, -1),
                            _createTextVNode("CANCELAR ")
                          ]), 8, _hoisted_58)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_BlockUI, {
      blocked: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["blocked"]),
    _createVNode(_component_ModalFileUpload, {
      visible: _ctx.isFileUploadVisible,
      askDescription: false,
      forceSquare: false,
      maxSizeMB: 2,
      fileTypes: ['image/png', 'image/jpg', 'image/jpeg'],
      onAccept: _ctx.onFileUploadAcepted,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => (_ctx.isFileUploadVisible = $event))
    }, null, 8, ["visible", "onAccept"]),
    (_ctx.showCropper)
      ? (_openBlock(), _createBlock(_component_CropperView, {
          key: 0,
          image: _ctx.beforeCropBase64,
          onClose: _ctx.onCropFinished
        }, null, 8, ["image", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}